import Vue from 'vue'
import { merge } from 'lodash'
import ResizeObserverPolyfill from 'resize-observer-polyfill'

const XS = 'xs'
const SM = 'sm'
const MD = 'md'
const LG = 'lg'
const XL = 'xl'

const defaultOptions = {
  [XS]: { gutter: '8px', margin: '16px' },
  [SM]: { gutter: '16px', margin: '16px' },
  [MD]: { gutter: '16px', margin: '24px' },
  [LG]: { gutter: '16px', margin: '64px' },
  [XL]: { gutter: '24px', margin: '64px' }
}

export default function install (vue, options) {
  options = merge(defaultOptions, options)
  const responseLayout = new Vue({
    data: {
      breakpoint: undefined,
      RESIZE_OBSERVER: undefined,
      options,
      width: 0
    },
    computed: {
      gutter: function () {
        return this.options[this.breakpoint]?.gutter ?? '0px'
      },
      margin () {
        return this.options[this.breakpoint]?.margin ?? '0px'
      },
      xsOnly () {
        return this.breakpoint === XS
      },
      smOnly () {
        return this.breakpoint === SM
      },
      mdOnly () {
        return this.breakpoint === MD
      },
      lgOnly () {
        return this.breakpoint === LG
      },
      xlOnly () {
        return this.breakpoint === XL
      },
      smAndUp () {
        return [SM, MD, LG, XL].includes(this.breakpoint)
      },
      mdAndUp () {
        return [MD, LG, XL].includes(this.breakpoint)
      },
      lgAndUp () {
        return [LG, XL].includes(this.breakpoint)
      },
      smAndDown () {
        return [XS, SM].includes(this.breakpoint)
      },
      mdAndDown () {
        return [XS, SM, MD].includes(this.breakpoint)
      },
      lgAndDown () {
        return [XS, SM, MD, LG].includes(this.breakpoint)
      }

    },
    created: function () {
      const ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill
      this.RESIZE_OBSERVER = new ResizeObserver(entries => {
        const { width } = entries[0].contentRect
        this.setBreakpoint(width)
      })
      this.RESIZE_OBSERVER.observe(document.documentElement)
    },
    beforeDestroy: function () {
      this.RESIZE_OBSERVER.disconect()
    },
    methods: {
      setBreakpoint: function (width) {
        this.width = width
        if (width >= 0 && width <= 599) this.breakpoint = XS
        if (width >= 600 && width <= 1023) this.breakpoint = SM
        if (width >= 1024 && width <= 1439) this.breakpoint = MD
        if (width >= 1440 && width <= 1919) this.breakpoint = LG
        if (width >= 1920) this.breakpoint = XL
      }
    }
  })
  vue.mixin({
    data: () => ({
      rl: responseLayout
    })
  })
}
